<template>
    <ul class="my-4">
        <li v-for="(item, index) in block.Items" :key="index" class="flex items-center mt-2">
            <span class="bg-red-700 rounded-full p-1">
                <svg class="w-6 h-6 text-red-200" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                </svg>
            </span>
            <span class="ml-2">{{ item.Text }}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "NegativeList",
        data() {
            return {
                block: {
                    Items: [
                        { Text: 'This is the first list item' },
                        { Text: 'This is a middle list item' },
                        { Text: 'This is the last list item' }
                    ]
                }
            }
        }
    };
</script>